<script>
import TownSelection from "@/components/TownSelection";
import SubmitButton from "@/components/SubmitButton";
import ErrorMessage from "@/components/ErrorMessage";
import { useUserStore } from "../../stores/user";
import { useTownSelectionStore } from "../../stores/townSelection";
import bus from "@/bus";

export default {
  setup() {
    const userStore = useUserStore();
    const townSelection = useTownSelectionStore();
    return {
      userStore,
      townSelection,
    }
  },
  components: {
    ErrorMessage,
    SubmitButton,
    TownSelection,
  },
  data() {
    return {
      editError: null,
      loadingState: 0,
    };
  },
  computed: {
    user() {
      return this.userStore.getData;
    },
    towns() {
      return this.user.townsData;
    },
  },
  methods: {
    async modifyTown() {
      this.loadingState = 1;
      const towns = this.townSelection.ids;
      const removedTowns = towns.filter(
        (townId) => this.towns.findIndex(({ id }) => townId === id) === -1
      );
      const addedTowns = this.towns
        .filter(({ id }) => towns.findIndex((townId) => townId === id) === -1)
        .map(({ id }) => id);
      const error = await this.userStore.modify({ towns: [...removedTowns, ...addedTowns], });
      this.loadingState = 2;
      if (error) {
        const {
          status,
          data: { message },
        } = error;
        this.editError = {
          status,
          message,
        };
      } else {
        bus.emit("closeModal");
      }
    },
  },
};
</script>

<template>
  <div class="p-8 z-50 bg-white shadow-xl rounded sm:min-w-md sm:max-w-2xl max-h-screen overflow-y-auto">
    <h2 class="text-3xl font-light text-lightGrey mb-4">
      {{ $t("views.modals.edit_user_town.title") }}<br />
    </h2>

    <ErrorMessage v-if="editError" :value="editError" @input="editError = null" />

    <form class="flex flex-col lg:flex-row flex-wrap mb-4" data-cy="modifyUserTownForm" @submit.prevent="modifyTown()">
      <TownSelection class="w-full" :starting-towns="towns" :init-expanded="true" />
      <div class="w-full flex flex-col justify-start items-end">
        <SubmitButton v-model="loadingState" class="mb-2" :texts="[
          $t('views.modals.edit_user_town.submit.1'),
          $t('views.modals.edit_user_town.submit.2'),
          $t('views.modals.edit_user_town.submit.3'),
        ]" />
      </div>
    </form>
  </div>
</template>

<style></style>
